import { useEffect, useState } from 'react';
import CohortGraph from 'react-cohort-graph';
import moment from 'moment';
import { Select } from 'antd';
import {
  useAppwatchSelector,
  useAppwatchDispatch,
  PaymentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartHeader } from '../ChartHeader';
import { ChartsProps } from '../types';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

const UserRetentionForMultiplePointsChart = ({ dates }: ChartsProps) => {
  const dispatch = useAppwatchDispatch();
  const [state, setState] = useState<'percentage' | 'value'>('value');

  const {
    userRetentionForMultiplePoints,
    userRetentionForMultiplePointsStatus,
  } = useAppwatchSelector((c) => c.paymentAnalysis);

  useEffect(() => {
    dispatch(
      PaymentAnalysisActions.getUserRetentionForMultiplePointsAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
      })
    );
  }, [dates]);

  const getGraph = () => {
    switch (state) {
      case 'value':
        return (
          <div>
            {' '}
            <CohortGraph
              data={{
                months: Object.fromEntries(
                  userRetentionForMultiplePoints.map((d) => [
                    moment(d.date).local().locale('en').format('YYYY-MM-DD'),
                    d.response?.map((ele) => ele.count) || 0,
                  ])
                ),
              }}
              defaultValueType={'value'}
              shadeColor={'#F9A3A4'}
            />
          </div>
        );
      case 'percentage':
        return (
          <CohortGraph
            data={{
              months: Object.fromEntries(
                userRetentionForMultiplePoints.map((d) => [
                  moment(d.date).local().locale('en').format('YYYY-MM-DD'),
                  d.response?.map((ele) => ele.count) || 0,
                ])
              ),
            }}
            defaultValueType={'percent'}
            shadeColor={'#F9A3A4'}
          />
        );
    }
  };

  return (
    <>
      <div className="col-span-2">
        {' '}
        <Card>
          <div className="space-y-2 min-h-[350px] h-full  overflow-x-auto  scrollbar-thin ">
            <div className="flex flex-row justify-between">
              <ChartHeader
                title="user Retention For Multiple Points"
                dates={dates}
              />
              <Select value={state} onChange={(e) => setState(e)}>
                <Select.Option value="value">أرقام</Select.Option>
                <Select.Option value="percentage">نسب</Select.Option>
              </Select>
            </div>
            {userRetentionForMultiplePointsStatus === 'loading' ? (
              <div className="loading h-[300px] flex justify-center items-center align-middle">
                <div className="spinner-border text-primary" role="status">
                  <span className="">
                    <ReturnTranslatedText text="general.Loading" />
                  </span>
                </div>
              </div>
            ) : (
              getGraph()
            )}
          </div>
        </Card>
      </div>{' '}
      <div className="col-span-2">
        {' '}
        <Card>
          <div className="space-y-2 min-h-[350px] h-full  overflow-x-auto  scrollbar-thin  ">
            <div className="flex flex-row justify-between">
              <ChartHeader
                title="user Churn For Multiple Points"
                dates={dates}
              />
            </div>
            {userRetentionForMultiplePointsStatus === 'loading' ? (
              <div className="loading h-[300px] flex justify-center items-center align-middle">
                <div className="spinner-border text-primary" role="status">
                  <span className="">
                    <ReturnTranslatedText text="general.Loading" />
                  </span>
                </div>
              </div>
            ) : (
              <CohortGraph
                data={{
                  months: Object.fromEntries(
                    userRetentionForMultiplePoints.map((d) => [
                      moment(d.date).local().locale('en').format('YYYY-MM-DD'),
                      d.response?.map((ele, i) => {
                        const firstValue = d.response?.[0]?.count ?? 0;
                        const currentCount = ele.count ?? 0;
                        return i === 0
                          ? currentCount
                          : firstValue - currentCount ?? 0;
                      }) || [],
                    ])
                  ),
                }}
                defaultValueType={'percent'}
                shadeColor={'#F9A3A4'}
              />
            )}
          </div>
        </Card>
      </div>{' '}
    </>
  );
};

export default UserRetentionForMultiplePointsChart;
